<template>
	<b-container id="main-content">
		<h2>New Application</h2>
		<b-form @submit.prevent="on_create_app">
			<b-row>
				<b-form-group label="What type of applicant are you?">
					<b-form-radio-group
						id="rbnGrpTrad"
						name="rbnGrpTrad"
						v-model="trad"
						:disabled="disabled_for_guests"
					>
						<b-form-radio
							value="traditional"
							v-b-tooltip.hover
							title="Current high school or college student, or anyone 24 years of age or younger at the time of application."
							v-focus
						>
							Traditional
						</b-form-radio>
						<b-form-radio
							value="nontraditional"
							v-b-tooltip.hover
							title="Anyone over the age of 24 at the time of application."
						>
							Non-Traditional
						</b-form-radio>
					</b-form-radio-group>
				</b-form-group>
			</b-row>

			<b-row>
				<b-form-group label="Are you a first-year or transfer student?">
					<b-form-radio-group id="rbnGrpYear" name="rbnGrpYear" v-model="year">
						<b-form-radio value="firstyear">First Year</b-form-radio>
						<b-form-radio value="transfer">Transfer</b-form-radio>
					</b-form-radio-group>
				</b-form-group>
			</b-row>

			<b-row>
				<b-form-group label="Select one or more campuses to apply to :">
					<b-form-checkbox-group v-model="selectedCampuses" :options="campuses">
					</b-form-checkbox-group>
				</b-form-group>
			</b-row>

			<b-row>
				<b-col>
					<b-btn variant="primary" :disabled="!form_is_valid" type="submit"
						>Continue</b-btn
					>
				</b-col>
				<b-col>
					<b-btn
						variant="secondary"
						size="sm"
						class="float-right"
						@click.prevent="cancel_action()"
					>
						Cancel
					</b-btn>
				</b-col>
			</b-row>
		</b-form>
		<spinner
			ref="spin"
			message="Please wait while we create your application"
		></spinner>
	</b-container>
</template>

<script>
import { mapGetters } from "vuex";
import spinner from "../spinner";

export default {
	components: {
		spinner
	},
	data() {
		return {
			trad: "",
			year: "",
			selectedCampuses: []
		};
	},
	computed: {
		...mapGetters([
			"campuses",
			"active_application_id",
			"userType",
			"studentType",
			"applicantType"
		]),
		form_is_valid() {
			return (
				this.selectedCampuses.length > 0 && this.trad !== "" && this.year !== ""
			);
		},
		disabled_for_guests() {
			return this.userType === "guest";
		}
	},
	methods: {
		on_create_app() {
			if (!this.form_is_valid) {
				return;
			}

			this.$store.dispatch("create_application", {
				trad: this.trad,
				year: this.year,
				campuses: this.selectedCampuses,
				axios: this.$axios
			});

			this.$refs.spin.show_modal();
		},
		cancel_action() {
			if (this.userType === "guest" || this.userType === "new") {
				this.$store.dispatch("logout_user");
				this.$router.push("/intro");
			} else if (this.userType === "authed") {
				this.$router.push("/applications");
			}
		}
	},
	created() {
		if (this.userType === "guest") {
			if (!this.applicantType) {
				this.$router.push("/intro");
			}
			this.$watch("year", function() {
				this.$store.commit("setStudentType", this.year);
			});
		}

		if (this.applicantType) {
			this.trad = this.applicantType;
		}

		if (this.studentType) {
			this.year = this.studentType;
		}
	},
	watch: {
		active_application_id(value) {
			if (value) {
				this.$router.push("/app");
			}
		}
	}
};
</script>

<style scoped></style>
